import axios from 'axios';

const parseStringParams = (name, params, bool) => {
	if (bool) {
		return (
			name +
			' ' +
			params?.supplyType +
			' ' +
			params?.vinMin +
			'-' +
			params?.vinMax +
			'V ' +
			'to ' +
			params?.vout +
			'V at ' +
			params?.iout +
			'A'
		);
	}
	return (
		name +
		params?.supplyType +
		' ' +
		params?.vinMin +
		'-' +
		params?.vinMax +
		' V ' +
		'to ' +
		params?.vout +
		'V at ' +
		params?.iout +
		'A'
	);
};

export const localLogCalculateDesigns = inputParams => {
	inputParams = parseStringParams('', inputParams);
	const obj = {
		wdt_design_name: inputParams
	};

	return recordEvent('WDT_CALCULATES_DESIGN', JSON.stringify(obj));
};

export const localLogOpenDesignByLink = (designName, params) => {
	designName = parseStringParams(designName, params, true);
	const obj = {
		wdt_design_name: designName
	};

	return recordEvent('WDT_OPENED_DESIGN_BY_LINK', JSON.stringify(obj));
};

export const localDownloadBom = (icPartNumber, params) => {
	icPartNumber = parseStringParams(icPartNumber, params, true);
	const obj = {
		wdt_design_name: icPartNumber
	};
	return recordEvent('WDT_DOWNLOAD_BOM', JSON.stringify(obj));
};

export const localLogOpenDesign = params => {
	const obj = {
		wdt_design_name: params
	};
	return recordEvent('WDT_OPEN_DESIGN', JSON.stringify(obj));
};

export const localView = (item, designName) => {
	if (!designName) {
		designName = 'designName_not_set';
	}

	const obj = {
		page_title: 'Web Designer+ Tool + ' + item + ' ' + designName,
		page_breadcrumbs: '/Design/Tools & Software/WebDesigner+ Design Tools/' + item,
		page_section: 'Design',
		page_segment: 'Tools & Software'
	};

	return recordEvent('WDT_VIEW', JSON.stringify(obj));
};

export const localDownloadDatasheet = async datasheetTrackingParameters => {
	const designName = parseStringParams(
		datasheetTrackingParameters.partNumber,
		JSON.parse(datasheetTrackingParameters.inputParameters),
		true
	);
	const obj = {
		wdt_design_name: designName,
		wdt_tab_name: datasheetTrackingParameters.wdtTabName,
		wdt_datasheet_link: datasheetTrackingParameters.redirectLink
	};
	return recordEvent('WDT_DOWNLOAD_DATASHEET', JSON.stringify(obj));
};

export function recordEvent(name, data) {
	axios
		.post('api/trackEvent', { name: name, data: data })
		.then(response => {
			//
		})
		.catch(error => {
			console.error('recordEvent error', error);
		});
}
